<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8">
        <hr>
        <form class="form-inline">
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="search" class="mr-2">Buscar por identificador</label>
            </div>
            <div class="col-auto">
              <input type="search" class="form-control mr-2" id="search" aria-describedby="searchHelp"
                     placeholder="NIF, pasaporte, matrícula..."
                     v-model="searchValue"
                     @input="searchValue=$event.target.value.toUpperCase()" required autofocus>
            </div>
            <div class="col-auto">
              <button class="btn btn-primary" type="submit" title="Buscar"
                      v-on:click.prevent="search">
                <i class="fa fa-search"></i>&nbsp;Buscar
              </button>

              <button class="btn btn-link float-right" @click="reloadPage">
                <i class="fas fa-redo"></i>&nbsp;Limpiar Búsqueda
              </button>
            </div>
          </div>
        </form>

        <div v-if="errors.length">
          <div v-for="(error, index) in errors" :key="index" class="invalid-feedback d-block">
            {{ error }}
          </div>
        </div>
        <hr>
      </div>
    </div>

    <list v-if="data" :data="data" :search="found" ref="list" />
  </div>
</template>

<script>
import axios from 'axios';
import List from './List';
import User from "../models/user";

export default {
  name: 'search',
  components: {List},

  data() {
    return {
      el: '#app',
      data: null,
      searchValue: process.env.VUE_APP_DEFAULT_SEARCH,
      errors: [],
      found: null,
      url: process.env.VUE_APP_API_BASE_URL + 'v3/external/user/search',
      error_messages: {
        blank: 'Es obligatorio especificar el identificador',
        format: 'Formato incorrecto',
        min: 'El número mínimo de caracteres es '
      }
    }
  },

  methods: {
    search() {
      this.data = null;
      this.errors = [];

      this.checkErrors();
      if (this.errors.length) {
        return;
      }

      const body = {
        search: this.searchValue,
      };
      const config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json'
        }
      };

      axios.post(this.url, body, config)
        .then(response => {
          if (response.status === 200) {
            if (response.data.data && Array.isArray(response.data.data)) {
              this.data = response.data.data.map(userData => User.getUser(userData));
            } else {
              this.errors.push('Formato de respuesta incorrecto');
              this.data = [];
            }

            this.found = this.searchValue;
          }
          if (response.status !== 200) {
            let message = response.data.message ? response.data.message : response.data.data;
            this.errors.push(message ? message : 'Error al realizar la búsqueda');
          }
        })
        .catch(error => {
          this.manageErrorsServer(error);
        })
      ;
    },

    checkErrors() {
      const app = document.getElementById('app');
      const min = app.dataset.min;

      if (!this.searchValue) {
        this.errors.push(this.error_messages.blank);
        return;
      }
      this.searchValue = this.formatValue(this.searchValue);
      if (this.searchValue.length < min) {
        this.errors.push(this.error_messages.min + min);
      }
      if (!/^[a-z0-9]+$/i.test(this.searchValue)) {
        this.errors.push(this.error_messages.format);
      }
    },

    formatValue(value) {
      return value.trim().replace(/ /g, '');
    },

    reloadPage() {
      window.location.reload();
    },

    manageErrorsServer(error) {
      if (error.response) {
        // Error de respuesta del servidor (4xx, 5xx)
        switch (error.response.status) {
          case 401:
            this.$emit('token-expired');
            // this.errors.push('Token de autorización inválido o expirado');
            break;
          case 403:
            this.errors.push('No tienes permisos para realizar esta búsqueda');
            break;
          case 404:
            this.errors.push('No se encontraron resultados');
            break;
          case 500:
            this.errors.push('Error interno del servidor');
            break;
          default:
            this.errors.push('Error interno del servidor');
            break;
        }
      } else if (error.request) {
        // Error de red o conexión
        this.errors.push('Error de conexión. Verifica tu conexión a internet');
      } else {
        // Otro tipo de error
        this.errors.push('Error inesperado al realizar la búsqueda');
      }

      this.data = null;
    }
  }
}
</script>
